import React from 'react';
import PropTypes from 'prop-types';

import {connect} from 'react-redux';

import {Form, Grid, Segment, Divider, Button} from 'semantic-ui-react';

import EntryInputContainer from '../containers/EntryInputContainer';

import * as types from '../constants/ActionTypes';
import * as actions from '../actions';

export const SOURCEMAP_OFF = 'off';
export const SOURCEMAP_INLINE = 'inline';
export const SOURCEMAP_SEPARATE = 'separate';

const SOURCEMAP_OPTIONS = [
    {text: 'Off', value: SOURCEMAP_OFF},
    {text: 'Inline', value: SOURCEMAP_INLINE},
    {text: 'Separate', value: SOURCEMAP_SEPARATE},
];

const STRING_ARRAY_ENCODING_OPTIONS = [
    {text: 'Off', value: 'false'},
    {text: 'Base64', value: 'base64'},
    {text: 'RC4', value: 'rc4'},
];

export const TARGET_BROWSER = 'browser';
export const TARGET_BROWSER_NO_EVAL = 'browser-no-eval';
export const TARGET_NODE = 'node';

const TARGET_OPTIONS = [
    {text: 'Browser', value: TARGET_BROWSER},
    {text: 'Browser No Eval', value: TARGET_BROWSER_NO_EVAL},
    {text: 'Node', value: TARGET_NODE},
];

export const IDENTIFIER_NAMES_GENERATOR_DICTIONARY = 'dictionary';
export const IDENTIFIER_NAMES_GENERATOR_HEXADECIMAL = 'hexadecimal';
export const IDENTIFIER_NAMES_GENERATOR_MANGLED = 'mangled';
export const IDENTIFIER_NAMES_GENERATOR_MANGLED_SHUFFLED = 'mangled-shuffled';

const IDENTIFIER_NAMES_GENERATOR_OPTIONS = [
    {text: 'dictionary', value: IDENTIFIER_NAMES_GENERATOR_DICTIONARY},
    {text: 'hexadecimal', value: IDENTIFIER_NAMES_GENERATOR_HEXADECIMAL},
    {text: 'mangled', value: IDENTIFIER_NAMES_GENERATOR_MANGLED},
    {text: 'mangled-shuffled', value: IDENTIFIER_NAMES_GENERATOR_MANGLED_SHUFFLED},
];

const Options = ({dispatch, options}) =>
    <Form className="OptionsForm">
        <Grid columns={4} relaxed stackable doubling>
            <Grid.Column style={{display: 'block'}}>
                <Segment basic>
                    <Button
                        fluid
                        onClick={() => dispatch(actions.resetOptions())}
                    >
                        Reset options
                    </Button>

                    <Divider/>

                    <Form.Checkbox
                        label='压缩成一行'
                        checked={options.compact}
                        onChange={() => dispatch(actions.toggleOption(types.TOGGLE_COMPACT_CODE))}/>

                    <Form.Select
                        label='标志符混淆方式'
                        value={options.identifierNamesGenerator}
                        fluid
                        onChange={(event, {value}) => dispatch(actions.setIdentifierNamesGenerator(value))}
                        options={IDENTIFIER_NAMES_GENERATOR_OPTIONS}/>

                    <EntryInputContainer
                        label='标志符字典'
                        disabled={options.identifierNamesGenerator !== IDENTIFIER_NAMES_GENERATOR_DICTIONARY}
                        actionAddEntryToState={(name) => dispatch(actions.addDictionaryIdentifier(name))}
                        actionRemoveEntryFromState={(name) => dispatch(actions.removeDictionaryIdentifier(name))}
                        placeholder="foo"
                        entries={options.identifiersDictionary}
                        buttonIcon="plus"/>

                    <Form.Input
                        label='标志符前缀'
                        value={options.identifiersPrefix}
                        placeholder=''
                        onChange={(event, {value}) => dispatch(actions.setIdentifiersPrefix(value))}
                    />

                    <Form.Checkbox
                        label='全局函数变量重命名'
                        checked={options.renameGlobals}
                        onChange={() => dispatch(actions.toggleOption(types.TOGGLE_RENAME_GLOBALS))}/>

                    <Form.Checkbox
                        label='属性重命名'
                        checked={options.renameProperties}
                        onChange={() => dispatch(actions.toggleOption(types.TOGGLE_RENAME_PROPERTIES))}/>

                    <Divider/>

                    <Form.Checkbox
                        label='Simplify'
                        checked={options.simplify}
                        onChange={() => dispatch(actions.toggleOption(types.TOGGLE_SIMPLIFY))}/>

                    <Divider/>

                    <Form.Checkbox
                        label='防止格式化'
                        checked={options.controlFlowFlattening}
                        onChange={() => dispatch(actions.toggleOption(types.TOGGLE_CONTROL_FLOW_FLATTENING))}/>

                    <Form.Input
                        type='number'
                        label='格式化系数'
                        value={options.controlFlowFlatteningThreshold}
                        min="0"
                        max="1"
                        step="0.1"
                        onChange={(event, {value}) => dispatch(actions.setControlFlowFlatteningThreshold(parseFloat(value)))}
                        disabled={!options.controlFlowFlattening}/>

                    <Divider/>

                    <Form.Checkbox
                        label='花指令注入'
                        checked={options.deadCodeInjection}
                        onChange={() => dispatch(actions.toggleOption(types.TOGGLE_DEAD_CODE_INJECTION))}/>

                    <Form.Input
                        type='number'
                        label='花指令注入阀值'
                        value={options.deadCodeInjectionThreshold}
                        min="0"
                        max="1"
                        step="0.1"
                        onChange={(event, {value}) => dispatch(actions.setDeadCodeInjectionThreshold(parseFloat(value)))}
                        disabled={!options.deadCodeInjection}/>


                </Segment>
            </Grid.Column>

            <Grid.Column>
                <Segment basic>

                    <Form.Checkbox
                        label='字符串转换为数组'
                        checked={options.stringArray}
                        onChange={() => dispatch(actions.toggleOption(types.TOGGLE_STRING_ARRAY))}/>

                    <Form.Checkbox
                        label='旋转字符串数组位置'
                        checked={options.rotateStringArray}
                        disabled={!options.rotateStringArrayEnabled}
                        onChange={() => dispatch(actions.toggleOption(types.TOGGLE_ROTATE_STRING_ARRAY))}/>

                    <Form.Checkbox
                        label='打乱字符串数组排序'
                        checked={options.shuffleStringArray}
                        disabled={!options.shuffleStringArrayEnabled}
                        onChange={() => dispatch(actions.toggleOption(types.TOGGLE_SHUFFLE_STRING_ARRAY))}/>

                    <Form.Select
                        disabled={!options.stringArrayEncodingEnabled}
                        label='字符串数组加密'
                        fluid
                        value={options.stringArrayEncoding}
                        onChange={(event, {value}) => dispatch(actions.setStringArrayEncoding(value))}
                        options={STRING_ARRAY_ENCODING_OPTIONS}/>

                    <Form.Input
                        type='number'
                        label='字符串转数组阀值'
                        value={options.stringArrayThreshold}
                        min="0"
                        max="1"
                        step="0.1"
                        onChange={(event, {value}) => dispatch(actions.setStringArrayThreshold(parseFloat(value)))}
                        disabled={!options.stringArrayThresholdEnabled}/>

                    <Divider/>

                    <Form.Checkbox
                        label='分割字符串'
                        checked={options.splitStrings}
                        onChange={() => dispatch(actions.toggleOption(types.TOGGLE_SPLIT_STRINGS))}/>

                    <Form.Input
                        type='number'
                        label='分割字符串块长度'
                        value={options.splitStringsChunkLength}
                        min="1"
                        step="1"
                        onChange={(event, {value}) => dispatch(actions.setSplitStringsChunkLength(parseInt(value)))}
                        disabled={!options.splitStringsChunkLengthEnabled}/>

                    <Divider/>

                    <Form.Checkbox
                        label='变量加密'
                        checked={options.transformObjectKeys}
                        onChange={() => dispatch(actions.toggleOption(types.TOGGLE_TRANSFORM_OBJECT_KEYS))}/>

                    <Divider/>

                    <Form.Checkbox
                        label='Numbers To Expressions'
                        checked={options.numbersToExpressions}
                        onChange={() => dispatch(actions.toggleOption(types.TOGGLE_NUMBERS_TO_EXPRESSIONS))}/>

                    <Divider/>

                    <Form.Checkbox
                        label='Unicode转义序列'
                        checked={options.unicodeEscapeSequence}
                        onChange={() => dispatch(actions.toggleOption(types.TOGGLE_UNICODE_ESCAPE_SEQUENCE))}/>

                </Segment>
            </Grid.Column>

            <Grid.Column>
                <Segment basic>

                    <Form.Checkbox
                        label='禁用控制台输出'
                        checked={options.disableConsoleOutput}
                        onChange={() => dispatch(actions.toggleOption(types.TOGGLE_DISABLE_CONSOLE_OUTPUT))}/>

                    <Divider/>

                    <Form.Checkbox
                        label='K保护'
                        checked={options.selfDefending}
                        onChange={() => dispatch(actions.toggleOption(types.TOGGLE_SELF_DEFENDING))}/>

                    <Divider/>

                    <Form.Checkbox
                        label='调试保护'
                        checked={options.debugProtection}
                        onChange={() => dispatch(actions.toggleOption(types.TOGGLE_DEBUG_PROTECTION))}/>

                    <Form.Checkbox
                        label='保护间隔'
                        checked={options.debugProtectionInterval}
                        disabled={!options.debugProtection}
                        onChange={() => dispatch(actions.toggleOption(types.TOGGLE_DEBUG_PROTECTION_INTERVAL))}/>

                    <Divider/>

                    <EntryInputContainer
                        label='锁定域名'
                        disabled={!options.domainLockEnabled}
                        actionAddEntryToState={(domain) => dispatch(actions.addDomainLock(domain))}
                        actionRemoveEntryFromState={(domain) => dispatch(actions.removeDomainLock(domain))}
                        placeholder="1json.com"
                        entries={options.domainLock}
                        buttonIcon="plus"/>

                    <EntryInputContainer
                        label='保留方法'
                        actionAddEntryToState={(name) => dispatch(actions.addReservedName(name))}
                        actionRemoveEntryFromState={(name) => dispatch(actions.removeReservedName(name))}
                        placeholder="^someVariable *or *RegExp"
                        entries={options.reservedNames}
                        buttonIcon="plus"/>

                    <EntryInputContainer
                        label='保留字符串'
                        actionAddEntryToState={(string) => dispatch(actions.addReservedString(string))}
                        actionRemoveEntryFromState={(string) => dispatch(actions.removeReservedString(string))}
                        placeholder="^some *string *or RegExp"
                        entries={options.reservedStrings}
                        buttonIcon="plus"/>

                </Segment>
            </Grid.Column>

            <Grid.Column>
                <Segment basic>

                    <Form.Select
                        label='Sourcemaps地图'
                        value={options.sourceMapMode}
                        fluid
                        onChange={(event, {value}) => dispatch(actions.setSourceMapMode(value))}
                        options={SOURCEMAP_OPTIONS}/>

                    <Form.Input
                        label='Source Map地址'
                        disabled={!options.sourceMapSeparate}
                        onChange={(event, {value}) => dispatch(actions.setSourceMapBaseUrl(value))}
                        value={options.sourceMapBaseUrl}
                        placeholder='http://www.1json.com'/>

                    <Form.Input
                        label='Source Map文件名'
                        disabled={!options.sourceMapSeparate}
                        onChange={(event, {value}) => dispatch(actions.setSourceMapFileName(value))}
                        value={options.sourceMapFileName}
                        placeholder='1jsonFile'/>

                    <Divider/>

                    <Form.Input
                        type='number'
                        label='加密种子'
                        value={options.seed}
                        min="0"
                        max="99999999"
                        step="1"
                        onChange={(event, {value}) => dispatch(actions.setSeed(parseInt(value)))}/>

                    <Divider/>

                    <Form.Select
                        label='运行环境'
                        value={options.target}
                        fluid
                        onChange={(event, {value}) => dispatch(actions.setTarget(value))}
                        options={TARGET_OPTIONS}/>

                </Segment>
            </Grid.Column>

        </Grid>
    </Form>;


Options.propTypes = {
    dispatch: PropTypes.func.isRequired,
    options: PropTypes.object,
};

const mapStateToProps = (state) => {
    return {
        options: state.options,
    }
};

export default connect(mapStateToProps)(Options);
